import * as React from 'react';
import classNames from 'classnames';
import {
  Colors,
  getVariantClass,
  getColorClasses,
  BackgroundColors,
  getBooleanVariants,
} from '../../utilities';

export type PaddingType = 'top_only' | 'bottom_only';

type SectionElementProps = JSX.IntrinsicElements['section'];

export interface SectionProps extends SectionElementProps {
  tight?: boolean;
  image?: boolean;
  border?: boolean;
  padding?: PaddingType;
  className?: string;
  backgroundColor?: BackgroundColors;
  color?: Colors;
}

const BASE_CLASS = 'section';
const PADDING_TOP = getVariantClass(BASE_CLASS, 'padding-top-only');
const PADDING_BOTTOM = getVariantClass(BASE_CLASS, 'padding-bottom-only');

export function Section({
  tight = false,
  image = false,
  border = false,
  color = 'primary',
  padding = '',
  className = '',
  backgroundColor = 'primary',
  ...restProps
} : SectionProps) {
  return (
    <section
      className={classNames(
        className,
        BASE_CLASS,
        getColorClasses(backgroundColor, color),
        getBooleanVariants(BASE_CLASS, {tight, border, image}), {
          [PADDING_TOP]: padding === 'top_only',
          [PADDING_BOTTOM]: padding === 'bottom_only',
        },
      )}
      {...restProps}
    />
  );
}

export default Section;
